const IMAGE_TYPE = /^image\/(jpeg|jpg|png|gif|webp|bmp)$/i;
const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp)$/i;

export const isPreviewableImage = (contentType, name) =>
  IMAGE_TYPE.test(contentType || '') || IMAGE_EXT.test(name || '');

const newId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `f-${Date.now()}-${Math.random().toString(16).slice(2)}`;

/**
 * Wrap a browser File so display name can differ from the stored original name.
 */
export const wrapPendingFile = (file, displayName) => {
  const originalName = file?.name || 'file';
  const contentType = file?.type || 'application/octet-stream';
  return {
    id: newId(),
    file,
    displayName: (displayName || originalName).slice(0, 200),
    originalName,
    contentType,
    size: file?.size || 0,
    previewUrl: isPreviewableImage(contentType, originalName) ? URL.createObjectURL(file) : null,
  };
};

export const revokePending = (item) => {
  if (item?.previewUrl) URL.revokeObjectURL(item.previewUrl);
};

export const pendingBlob = (item) => item?.file || item;

export const pendingMeta = (item) => ({
  name: String(item.displayName || item.name || '').trim(),
  originalName: item.originalName || item.file?.name || item.name,
  contentType: item.contentType || item.file?.type || item.type || 'application/octet-stream',
  sizeBytes: item.size != null ? item.size : item.file?.size || item.sizeBytes,
});
